import { normalizeDocumentContext, type NormalizeDocumentContextOptions } from '@/document-render/application/normalizeDocumentContext';
import type { DocumentContext } from '@/document-render/domain/DocumentContext';

export interface PreviewContextApiDto {
  applicationKey: string;
  moduleKey: string;
  documentTypeKey: string;
  context: Record<string, unknown>;
}

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const mapPreviewContextDto = (dto: PreviewContextApiDto, options?: NormalizeDocumentContextOptions): DocumentContext => {
  return normalizeDocumentContext(dto.context, options);
};

export const mergePreviewContext = (base: DocumentContext, patch: Record<string, unknown>): DocumentContext => {
  const merged: Record<string, unknown> = { ...base };

  for (const [key, value] of Object.entries(patch)) {
    if (isPlainObject(value) && isPlainObject(merged[key])) {
      merged[key] = { ...(merged[key] as Record<string, unknown>), ...value };
      continue;
    }

    merged[key] = value;
  }

  return merged as DocumentContext;
};
